import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {first} from 'rxjs/operators';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {SupportService} from '../../shared/services/support.service';
import {UserService} from '../../shared/services/user.service';
import {ModalService} from '../../shared/services/modal.service';
import {NavigationService} from '../../shared/services/navigation.service';
import {StateService} from '../../services/state.service';

@Component({
    selector: 'course-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
})
export class SupportComponent extends OnDestroyMixin implements OnInit {
    article;
    slugs: string[] = [];

    constructor(
        private supportService: SupportService,
        private activatedRoute: ActivatedRoute,
        public userService: UserService,
        private modalService: ModalService,
        public navigationService: NavigationService,
        public stateService: StateService
    ) {
        super();
    }

    ngOnInit() {
        this.initArticle();
    }

    initArticle() {
        this.activatedRoute.params.pipe(
            untilComponentDestroyed(this)
        ).subscribe(
            (routeParams) => {
                const slugs = [];

                for (const param of Object.keys(routeParams)) {
                    if (param.includes('slug')) {
                        slugs.push(routeParams[param]);
                    }
                }

                this.slugs = slugs;

                this.article = this.supportService.getArticle(slugs);
            }
        );
    }

    isMatIcon(icon: string) {
        return !icon.includes('.svg');
    }

    showPin() {
        this.supportService.getPin().pipe(
            first()
        ).subscribe(
            (pinCode) => {
                this.modalService.setModal('showPin', {pinCode});
            }
        );
    }
}

